"use client";
import { Button } from "antd";
import styles from "./SignUp.pc.module.scss";
import { postNotification } from "bossjob-remote/dist/clientStorage";

type propsType = {
  sessionid: string | undefined;
  data: { [key: string]: string };
};

const SignUp = ({ data, sessionid }: propsType) => {
  const handleSendEmailTOP = () => {
    sessionStorage.setItem("redirectPage", window?.location?.pathname);
    postNotification("SHOW_LOGIN_MODAL");
    return;
  };

  if (!sessionid) {
    return (
      <div className={styles.signUp}>
        <h3>{data.title}</h3>
        <Button onClick={handleSendEmailTOP}>{data.btn}</Button>
      </div>
    );
  }
  return null;
};

export default SignUp;
